module.exports = __webpack_public_path__ + "static/media/otm-doc.f7054a9c.png";